import { DateModel } from '../../types';

const hasDatePart = (value: DateModel | null | undefined): value is DateModel => {
  return !!value && (value.month !== undefined || value.day !== undefined || value.year !== undefined);
};

export const formatNaturalDateInput = (value: string): string => {
  const isoDate = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (isoDate) {
    return `${isoDate[2].padStart(2, '0')}/${isoDate[3].padStart(2, '0')}/${isoDate[1]}`;
  }

  if (value.includes('/')) {
    const parts = value.split('/');
    const month = (parts[0] || '').replace(/\D/g, '').slice(0, 2);
    const rawDay = (parts[1] || '').replace(/\D/g, '');
    const day = rawDay.slice(0, 2);
    const hasYearSegment = parts.length > 2 || rawDay.length > 2;
    const year = (parts.length > 2 ? parts[2] || '' : rawDay.slice(2)).replace(/\D/g, '').slice(0, 4);

    if (year.length === 4 && month && day) {
      return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
    }
    if (hasYearSegment && !year) {
      return `${month}/${day}`;
    }
    if (!hasYearSegment && !day) {
      return month;
    }
    return hasYearSegment ? `${month}/${day}/${year}` : `${month}/${day}`;
  }

  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) {
    return digits;
  }
  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const parseNaturalDateInput = (value: string): DateModel => {
  const normalizedValue = formatNaturalDateInput(value);
  const [month = '', day = '', year = ''] = normalizedValue.split('/');
  return {
    month: month ? Number(month) : undefined,
    day: day ? Number(day) : undefined,
    year: year.length === 4 ? Number(year) : undefined,
  };
};

export const toNaturalDateInputValue = (value: DateModel | null | undefined): string => {
  if (!hasDatePart(value)) {
    return '';
  }
  const month = value.month === undefined ? '' : String(value.month).padStart(2, '0');
  const day = value.day === undefined ? '' : String(value.day).padStart(2, '0');
  const year = value.year === undefined ? '' : String(value.year);
  if (year) {
    return `${month}/${day}/${year}`;
  }
  if (day) {
    return `${month}/${day}`;
  }
  return month;
};
